import { password } from "@covertree/utils";
import { object, ref, ObjectSchema, string } from "yup";

export interface CreateNewPasswordFormData {
  code?: string;
  password: string;
  confirmPassword: string;
}

export const defaultValues: CreateNewPasswordFormData = {
  code: "",
  password: "",
  confirmPassword: "",
};

export const validationSchema = (
  isPasswordReset: boolean
): ObjectSchema<CreateNewPasswordFormData> =>
  object({
    ...(isPasswordReset
      ? { code: string().required("Code is required") }
      : { code: string() }),
    password: password(),
    confirmPassword: string()
      .oneOf([ref("password")], "Passwords don't match!")
      .required("Confirm password is required"),
  });
